import React from 'react';
import {Popover, HoverStyles, ButtonPriority, TextButtonPriority, PopoverTriggerAction} from 'wix-ui-tpa';
import {Country} from '../../../commons/data/countiresWithCurrencies';
import {FlagIcon} from '../../../commons/components/FlagIcon/FlagIcon';
import {classes as st} from './PopoverWrapper.st.css';
import {KeepButton, SuggestionActions, SwitchButton, SwitchButtonContent} from './PopoverWrapper.styles';

export const PopoverWrapper = ({
  children,
  isMobile,
  setIsOpen,
  onChange,
  selectedCurrency,
  userCountryInfo,
  useFlagIconInSuggestionPopover,
  getTranslationByKey,
  sendBIEventOnButtonClick,
}: {
  children: React.ReactNode;
  isMobile: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onChange: (currency: string) => void;
  selectedCurrency: string;
  userCountryInfo?: Country;
  useFlagIconInSuggestionPopover: boolean;
  getTranslationByKey: (key: string, params?: Record<string, any>) => string;
  sendBIEventOnButtonClick: (status: boolean) => void;
}) => {
  const switchToLabel = getTranslationByKey('currencyConverter.dropdown.defaultCurrency.switch-to', {
    currency: userCountryInfo?.currency,
    flag: useFlagIconInSuggestionPopover ? '' : userCountryInfo?.flagEmoji ?? '',
  }).trim();

  return (
    <Popover
      triggerAction={PopoverTriggerAction.click}
      shown={true}
      placement="bottom-end"
      width={isMobile ? 170 : 300}
      className={st.popover}
      contentClassName={isMobile ? st.popoverContentForMobile : st.popoverContent}>
      <Popover.Element>{children}</Popover.Element>
      <Popover.Content>
        <SuggestionActions isMobile={isMobile}>
          <SwitchButton
            priority={ButtonPriority.basic}
            hoverStyle={HoverStyles.underline}
            onClick={() => {
              if (!userCountryInfo?.currency) {
                return;
              }

              setIsOpen(false);
              onChange(userCountryInfo.currency);
              localStorage.setItem('selectedCurrency', userCountryInfo.currency);
              sendBIEventOnButtonClick(true);
            }}>
            <SwitchButtonContent>
              {useFlagIconInSuggestionPopover && <FlagIcon countryCode={userCountryInfo?.flagCountryCode} size={22} />}
              <span>{switchToLabel}</span>
            </SwitchButtonContent>
          </SwitchButton>
          <KeepButton
            priority={TextButtonPriority.link}
            hoverStyle={HoverStyles.underline}
            onClick={() => {
              setIsOpen(false);
              sendBIEventOnButtonClick(false);
            }}>
            {getTranslationByKey('currencyConverter.dropdown.defaultCurrency.keep', {
              currency: selectedCurrency,
            })}
          </KeepButton>
        </SuggestionActions>
      </Popover.Content>
    </Popover>
  );
};
